import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;
const clientApiUrl = process.env.REACT_APP_CLIENT_API_URL;

const ReportSettingAPI = {
	getReportSetting: (organization: ReportSettingRequest) => {
		return axios.get(`${apiUrl}/organizations/${organization.organizationId}/reportsettings`)
			.then((response) => response.data as ReportSettingDTO);
	},
	updateReportSetting: (organizationId: number, reportSetting: ReportSettingUpsertRequest) => {
		return axios.post(`${apiUrl}/organizations/${organizationId}/report-settings`, reportSetting)
			.then((response) => response.data as ReportSettingDTO);
	},
	upsertReportSettingLogo: (logo: File) => {
		const data = new FormData();
		data.append('file', logo);

		return axios.post(`${apiUrl}/report-settings/logo-upload`, data)
			.then((response) => response.data as string);
	},

	// client site methods
	getClientSiteReportSetting: (request: ClientSiteReportSettingRequest) => {
		return axios.get(`${clientApiUrl}/organizations/${request.organizationId}/datasets/${request.datasetId}/reportSettings`)
			.then(res => res.data as ReportSettingDTO);
	}
};

export default ReportSettingAPI;